import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/product"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "品为云官网_首页"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "品为云官网_产品介绍"
          },
          children: [
            {
              path: "/software",
              redirect: "/software/smartTown"
            },
            {
              path: "/software/smartTown",
              name: "software",
              component: resolve =>
                require(["@/view/Software_smartTown"], resolve),
              meta: {
                title: "品为云官网_产品介绍"
              }
            },
            {
              path: "/software/bigData",
              name: "software",
              component: resolve =>
                require(["@/view/Software_bigData"], resolve),
              meta: {
                title: "品为云官网_产品介绍"
              }
            }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "品为云官网_相关服务"
          }
        },
        {
          path: "/register",
          name: "register",
          component: resolve => require(["@/view/register"], resolve),
          meta: {
            title: "品为云官网_注册"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "品为云官网_套餐"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "品为云官网_工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "联系我们"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        }
      ]
    },

    {
      path: "/product",
      name: "product",
      component: resolve => require(["@/view/product/index"], resolve),
      meta: {
        title: "首页"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js